import React from 'react';
import { motion } from 'framer-motion';
export function PlatformClosing() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-319">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-320">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark mb-8 leading-tight" data-id="element-321">
          More than a platform for measurement
        </h2>

        <p className="text-xl text-ink-muted leading-relaxed" data-id="element-322">
          SyNeural is designed to help societies produce people who can think
          more clearly, regulate themselves more effectively, resist
          manipulation more consistently, cooperate more constructively, and
          lead more responsibly. The platform begins with assessment, but its
          larger purpose is development. It is designed to help individuals
          grow, institutions strengthen, communities stabilize, and leadership
          become more competent over time.
        </p>
      </motion.div>
    </section>;
}